<template>
  <v-sheet color="white" height="100px" class="d-flex align-center">
    <v-container class="py-0">
      <div class="d-flex justify-space-between align-center">
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="70px"
          />
        </router-link>

        <div class="ml-auto">
          <div
            v-for="({ text, to }, key) in menu"
            :key="key"
            class="d-inline-flex"
          >
            <v-btn
              class="
                text-none
                px-0
                py-3
                mx-3
                text-subtitle-1
                nav-link
                primary--text
              "
              min-width="min-content"
              v-if="to"
              :to="to"
              tile
              depressed
              text
            >
              {{ text }}
            </v-btn>
          </div>

          <div class="d-inline-flex ml-5">
            <v-btn
              v-for="({ title, link, icon, size }, key) in social"
              :key="key"
              class="primary--text text-subtitle-1 mx-2 social-link"
              :href="link"
              :title="title"
              target="_blank"
              width="40px"
              height="40px"
              icon
            >
              <v-icon :size="size"> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { getSocial } from "../../../config";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    time: "",
  }),
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  border-bottom: 4px solid transparent;
  transition: all 0.1s linear;
  &:hover {
    border-bottom: 4px solid #dedede;
  }
  &.v-btn--active {
    border-bottom: 4px solid var(--v-secondary-base);
    &:hover {
      border-bottom: 4px solid var(--v-secondary-base);
    }
  }
  &:before {
    opacity: 0 !important;
  }
}

.social-link {
  border: 1px solid var(--v-primary-base) !important;
  background-color: transparent !important;
  border-radius: 25rem;
  &:hover {
    background-color: var(--v-primary-base) !important;
    color: white !important;
  }
}
</style>
